// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Js_dict from "rescript/lib/es6/js_dict.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as UrlUtils$FeedSync from "./UrlUtils.bs.mjs";
import * as RescriptReactRouter from "@rescript/react/src/RescriptReactRouter.bs.mjs";

function buildPath(path) {
  var path$1 = Belt_Array.reduce(Belt_Array.mapWithIndex(Belt_Array.keep(path, (function (x) {
                  return x.trim() !== "";
                })), (function (i, part) {
              return part.trim().replace(/(^[\/]*|[\/]*$)/g, "");
            })), "", (function (acc, curr) {
          var separator = curr.startsWith("?") || curr.startsWith("#") ? "" : "/";
          return acc + separator + curr;
        }));
  if (path$1.startsWith("/")) {
    return path$1;
  } else {
    return "/" + path$1;
  }
}

function goTo(replaceStateOpt, hash, queryOpt, preserveQueryParamsOpt, subpath) {
  var replaceState = replaceStateOpt !== undefined ? replaceStateOpt : false;
  var query = queryOpt !== undefined ? Caml_option.valFromOption(queryOpt) : ({});
  var preserveQueryParams = preserveQueryParamsOpt !== undefined ? preserveQueryParamsOpt : [
      "token",
      "user_id"
    ];
  var match = subpath.length;
  var subpath$1 = match !== 0 ? "/" + subpath.join("/") : "";
  var currentQueryParams = UrlUtils$FeedSync.getCurrentQueryParams(undefined);
  Belt_Array.forEach(preserveQueryParams, (function (param) {
          Belt_Option.forEach(Js_dict.get(currentQueryParams, param), (function (value) {
                  if (Js_dict.get(query, param) === undefined) {
                    query[param] = value;
                    return ;
                  }
                  
                }));
        }));
  var search = UrlUtils$FeedSync.toString(query);
  var hash$1 = Belt_Option.mapWithDefault(hash, "", (function (hash) {
          return "#" + hash;
        }));
  var path = buildPath([
        subpath$1,
        search,
        hash$1
      ]);
  if (replaceState) {
    return RescriptReactRouter.replace(path);
  } else {
    return RescriptReactRouter.push(path);
  }
}

export {
  buildPath ,
  goTo ,
}
/* RescriptReactRouter Not a pure module */
